import { h, render } from 'preact';
import Swiper, { Navigation, Scrollbar } from 'swiper';
import 'swiper/css/navigation';
import 'swiper/css/scrollbar';
import CollectionBanner from './collection-banner';

export default (element, data) => {
  const bannerSection = element.querySelector('[data-banner]');
  const init = () => {
    if (data?.collection?.hideBanner) return null;
    return render(<CollectionBanner {...data} />, bannerSection);
  };

  const initSlider = () => {
    const selector = element.querySelector('[data-slider]');
    const nextEl = element.querySelector('[data-nav-next]');
    const prevEl = element.querySelector('[data-nav-prev]');
    const scrollbarEl = element.querySelector('[data-nav-scrollbar]');
    // eslint-disable-next-line no-unused-vars
    const slider = new Swiper(selector, {
      modules: [Navigation, Scrollbar],
      slidesPerView: 3.3,
      spaceBetween: 12,
      slidesOffsetBefore: 15,
      slidesOffsetAfter: 15,
      scrollbar: {
        el: scrollbarEl,
        draggable: true,
        enabled: true,
      },
      breakpoints: {
        480: {
          slidesPerGroup: 2,
        },
        768: {
          slidesPerView: 4.6,
          slidesPerGroup: 3,
        },
        1024: {
          spaceBetween: 15,
          slidesOffsetBefore: 40,
          slidesOffsetAfter: 0,
          scrollbar: {
            enabled: false,
          },
          navigation: {
            nextEl,
            prevEl,
          },
        },
        1280: {
          slidesPerView: 7.8,
          slidesPerGroup: 4,
          slidesOffsetBefore: 40,
          slidesOffsetAfter: 0,
          navigation: {
            nextEl,
            prevEl,
          },
        },
        1440: {
          slidesPerView: 9.6,
          slidesOffsetBefore: 40,
          slidesOffsetAfter: 0,
          navigation: {
            nextEl,
            prevEl,
          },
        },
      },
    });

    selector?.querySelector('.swiper-wrapper').classList.remove('flex', '[&>div]:max-w-[10rem]', 'gap-x-16');

    // center the slider when the navigation buttons are hidden (eg: only 6 slides on desktop)
    if (nextEl?.classList.contains('swiper-button-lock') && prevEl?.classList.contains('swiper-button-lock')) {
      selector?.querySelector('.swiper-wrapper')?.classList.add('justify-center');
    }
  };

  initSlider();
  init();
};
